import { ethers } from "ethers";

export async function connectWallet() {

  if (!window.ethereum) return;

  const provider = new ethers.BrowserProvider(window.ethereum);

  const accounts = await provider.send("eth_requestAccounts", []);

  return accounts[0];

}